import { Table, TableBody, TableContainer, TableRow } from "@material-ui/core";
import React from "react";
import TestRequestExportParameterResponse, {
  IdNameObj,
} from "../../api/models/advanced-search/TestRequestExportParameterResponse";
import VerticalAlignedChip from "../../components/Chip/VerticalAlignedChip";
import ExcelExportParameter from "../../models/ExcelExportParameter";
import TableListCell from "../Requests/TestTab/TableListCell";

interface ExcelResultsTableProps {
  configuredResults?: TestRequestExportParameterResponse;
  updateConfiguredResults: (field: ExcelExportParameter, value: IdNameObj) => void;
}

const ExcelResultsTable = (props: ExcelResultsTableProps) => {
  const { configuredResults, updateConfiguredResults } = props;

  return (
    <TableContainer>
      <Table>
        <TableBody>
          <TableRow>
            <TableListCell
              component={VerticalAlignedChip}
              mandatory
              name="substrateSamples"
              list={configuredResults?.substrateClasses || []}
              onElementDelete={(element) => {
                updateConfiguredResults(ExcelExportParameter.SUBSTRATES, element.value);
              }}
              title="Substrates"
            />
            <TableListCell
              component={VerticalAlignedChip}
              mandatory
              name="productSamples"
              list={configuredResults?.tesaProducts.map((product, index) => ({ name: product, id: index })) || []}
              onElementDelete={(element) => {
                updateConfiguredResults(ExcelExportParameter.TESA_PRODUCTS, element.value);
              }}
              title="Products"
            />
            <TableListCell
              component={VerticalAlignedChip}
              mandatory
              name="testMethods"
              list={configuredResults?.testMethods || []}
              onElementDelete={(element) => {
                updateConfiguredResults(ExcelExportParameter.TEST_METHODS, element.value);
              }}
              title="Test Methods"
            />
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ExcelResultsTable;
